import type { OrgMemberRole } from '@/types/org';
import { ORG_MEMBER_ROLE_LABELS } from '@/types/org';

const STRING_ROLE_TO_VALUE: Record<string, OrgMemberRole> = {
  owner: 1,
  admin: 2,
  member: 3,
};

const ROLE_TEXT_REPLACEMENTS: Array<[RegExp, string]> = [
  [/(^|[^A-Z0-9_])OWNER\/ADMIN(?=$|[^A-Z0-9_])/g, '$1超级管理员/管理员'],
  [/(^|[^A-Z0-9_])OWNER(?=$|[^A-Z0-9_])/g, '$1超级管理员'],
  [/(^|[^A-Z0-9_])ADMIN(?=$|[^A-Z0-9_])/g, '$1管理员'],
  [/(^|[^A-Z0-9_])MEMBER(?=$|[^A-Z0-9_])/g, '$1普通成员'],
];
const LOCALIZED_ROLE_LABEL_PATTERN = '(?:超级管理员\\/管理员|超级管理员|管理员|普通成员)';
const ROLE_PREFIX_SPACE_PATTERN = new RegExp(
  `([\\u4e00-\\u9fff「（【])\\s+(${LOCALIZED_ROLE_LABEL_PATTERN})`,
  'g'
);
const ROLE_SUFFIX_SPACE_PATTERN = new RegExp(
  `(${LOCALIZED_ROLE_LABEL_PATTERN})\\s+([\\u4e00-\\u9fff」）】，。；、])`,
  'g'
);

function normalizeOrgMemberRole(value: unknown): OrgMemberRole | null {
  if (value === 1 || value === 2 || value === 3) {
    return value;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === '1' || normalized === '2' || normalized === '3') {
    return Number(normalized) as OrgMemberRole;
  }

  return STRING_ROLE_TO_VALUE[normalized] ?? null;
}

export function getOrgMemberRoleLabel(value: unknown, fallback = '普通成员'): string {
  const role = normalizeOrgMemberRole(value);
  return role ? ORG_MEMBER_ROLE_LABELS[role] : fallback;
}

export function localizeOrgRoleEnumText(text: string): string {
  return ROLE_TEXT_REPLACEMENTS.reduce(
    (result, [pattern, replacement]) => result.replace(pattern, replacement),
    text
  )
    .replace(ROLE_PREFIX_SPACE_PATTERN, '$1$2')
    .replace(ROLE_SUFFIX_SPACE_PATTERN, '$1$2');
}
